import { render, staticRenderFns } from "./list-general.vue?vue&type=template&id=19567c09"
import script from "./list-general.vue?vue&type=script&lang=js"
export * from "./list-general.vue?vue&type=script&lang=js"
import style0 from "./list-general.vue?vue&type=style&index=0&id=19567c09&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports